import { AskQuestionView  } from "@/features/patient/ask-ai/components/AskQuestionView";
import { usePatientData } from "@/portals/patient/context/PatientDataContext";

export function AskPage() {
  const { records } = usePatientData();
  return <AskQuestionView records={records} />;
}
